import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MdiIcon } from '@mic3/platform-ui';
import { Tooltip, IconButton, Menu, MenuItem } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { changeBaseLayer } from 'app/utils/maps/layer/layerUtils';

const DropdownContainer = styled.div`
  display: inline-flex;
  align-items: center;
`;

const StyledIconButton = styled(IconButton)`
  padding: 8px;
  margin: 0 4px;
`;

const BaseLayerDropdown = ({ activeLayer, onLayerChange, mapInstance }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const mapSettings = useSelector(state => state.app.configurations.affectli.map || {})
    const { enableGoogleMaps, feGoogleApiKey, baseLayerOptions } = mapSettings || {}

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const updateMapLayer = useCallback(() => {
        changeBaseLayer(mapInstance, activeLayer, enableGoogleMaps, feGoogleApiKey);
    },[mapInstance, activeLayer, enableGoogleMaps, feGoogleApiKey]);

    useEffect(() => {
        if(mapInstance && activeLayer){
            updateMapLayer(activeLayer)
        }
    },[activeLayer, mapInstance, updateMapLayer])

    const handleLayerChange = (layer) => {
        onLayerChange(layer);
        handleClose();
    };

    return (
        <DropdownContainer>
            <Tooltip title="Select Base Layer">
                <StyledIconButton 
                    aria-controls="base-layer-menu" 
                    aria-haspopup="true" 
                    onClick={handleClick}
                >
                    <MdiIcon name="earth" />
                </StyledIconButton>
            </Tooltip>
            <Menu
                id="base-layer-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {baseLayerOptions.map((layer) => (
                    <MenuItem 
                        key={layer.label} 
                        onClick={() => handleLayerChange(layer)}
                        selected={layer.label === activeLayer?.label}
                    >
                        {layer.label}
                    </MenuItem>
                ))}
            </Menu>
        </DropdownContainer>
    );
};

BaseLayerDropdown.propTypes = {
    activeLayer: PropTypes.object,
    onLayerChange: PropTypes.func.isRequired
};

export default BaseLayerDropdown;
